(function ($) {
  var $theMenu = $('#menuStrip');
  var $nav = $('#menuStrip nav');
  var $btn = $('#menuStrip .btn-more');
  var $visiblelinks = $('#menuStrip #parent-nav');
  var $hiddenlinks = $('#menuStrip #hidden-nav');
  var $ctalinks = $('#menuStrip #cta');
  var breaks = [];
  var $findCTA = '';

  // If a CTA exists, remove it, get it's info and put it into $ctalinks
  if ($visiblelinks.children().last().hasClass('CTA')) {
      $findCTA = $visiblelinks.children().last().find('a');
      var thelink = $('<a>', {
        text: $findCTA.attr('name'),
        class: 'btn btn-primary btn-cta ms-5',
        title: $findCTA.attr('title'),
        href: $findCTA.attr('href'),
        role: 'button',
        html: $findCTA.html()
      }).appendTo($ctalinks);
      $findCTA.parent().remove();
    }

  function updateStripNav() {
    var availableSpace = $btn.hasClass('invisible') ? $nav.width() : $nav.width() - $btn.outerWidth();
    // The visible list is overflowing the nav

    if ($visiblelinks.width() > availableSpace) {      
    // Record the width of the list
      breaks.push($visiblelinks.width());

      // Move item to the invisible list
      $visiblelinks.children().last().prependTo($hiddenlinks);

      // Show the dropdown btn
      if ($btn.hasClass('invisible')) {
        $btn.removeClass('invisible');
      }

      // The visible list is not overflowing
    } else {

      // There is space for another item in the nav
      if (availableSpace > breaks[breaks.length - 1]) {

        // Move the item to the visible list
        $hiddenlinks.children().first().appendTo($visiblelinks);
        breaks.pop();
      }

      // Hide the dropdown btn if invisible list is empty
      if (breaks.length < 1) {
        $btn.addClass('invisible');
        $hiddenlinks.addClass('invisible');
      }
    }

    // Keep counter updated
    $btn.attr("count", breaks.length);

    // Recur if the visible list is still overflowing the nav
    if ($visiblelinks.width() > availableSpace) {
      updateStripNav();
    }

  }



 

  /* ********************************** */
  /* SHOW EXTENDED DEPTH BOOTSTRAP MENUS - Specific to menu strip */
  /* ********************************** */
  const CLASS_NAME = 'has-child-dropdown-show';
  bootstrap.Dropdown.prototype.toggle = function (_original) {
    return function () {
      if (this._element.closest('#menuStrip')) {
        document.querySelectorAll('#menuStrip .' + CLASS_NAME).forEach(function (e) {
          e.classList.remove(CLASS_NAME);
        });

        let dd = this._element.closest('.dropdown').parentNode.closest('.dropdown');
        for (; dd && dd !== document; dd = dd.parentNode.closest('.dropdown')) {
          dd.classList.add(CLASS_NAME);
        }
      }
      return _original.call(this);
    };
  }(bootstrap.Dropdown.prototype.toggle);

  document.querySelectorAll('#menuStrip .dropdown').forEach(function (dd) {
    dd.addEventListener('hide.bs.dropdown', function (e) {
      if (this.classList.contains(CLASS_NAME)) {
        this.classList.remove(CLASS_NAME);
        e.preventDefault();
      }
      if (e.clickEvent && e.clickEvent.composedPath().some(el => el.classList && el.classList.contains(CLASS_NAME))) {
        e.preventDefault();
      }
      e.stopPropagation(); // do not need pop in multi level mode
    });
  });


    /* ********************************** */
  /* LISTENERS */
  /* ********************************** */
  $(window).resize(function () {
    updateStripNav();
  });
  $btn.on('click', function () {
    $hiddenlinks.toggleClass('invisible');
    $btn.toggleClass('active');
  });

  // Hide hidden menu when the main dropdowns are opened.
  $visiblelinks.bind('shown.bs.dropdown', function () {
    $hiddenlinks.addClass('invisible');
    $btn.removeClass('active');

  });
  updateStripNav();




})(jQuery);